var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "cache-id": "6bf9caa6811c44ebae60ce5310dd7fc3",
    id: "eIBPnRX5q9W1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 511.285 286",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.497905 0 0 0.503202-127.285923-14.113101)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M425.712,465.099l-160-458.667c-3.008-8.576-17.152-8.576-20.139,0l-160,458.667c-.405,1.131-.597,2.304-.597,3.52c0,41.472,55.966282,169.413217,170.666663,169.413217s170.667337-127.941217,170.667337-169.413217c-.001-1.195-.193-2.39-.598-3.52Z",
    transform: "matrix(1 0 0 0.89029 0 28.046593)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCone);
export default __webpack_public_path__ + "static/media/cone.d2d76711886bc2b764dffd77f3e6e0ae.svg";
export { ForwardRef as ReactComponent };